module.exports = __webpack_public_path__ + "img/coin.98491019.gif";